import { render } from "./FinCoinDisplay.vue?vue&type=template&id=6e5359d6&scoped=true"
import script from "./FinCoinDisplay.vue?vue&type=script&lang=js"
export * from "./FinCoinDisplay.vue?vue&type=script&lang=js"

import "./FinCoinDisplay.vue?vue&type=style&index=0&id=6e5359d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5359d6"]])

export default __exports__